<template lang="pug">
  .product-item

    v-card.mb-2(style="border-radius: 0px")
      v-layout.pa-0
        v-img.ma-2(:src="image.image ? image.image.file : require('@/assets/image_placeholder.png')" max-width="110px" width="110px" height="110px")
        v-col.mr-2.py-2.px-0
          v-row(align="end")
            v-col.pb-2.pt-0
            v-col.py-0.pl-0(cols="5" align="end")
              v-btn(icon @click="clickDelete")
                v-icon(color="#6E6E6E") mdi-delete-outline

    .modals
      y-dialog(v-model='openDeleteDialog', max-width='290' persistent)
        v-card
          v-card-title.title {{ $t('delete_image') }}
          v-card-text
            | {{ $t('delete_image_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='grey' text @click='openDeleteDialog = false')
              | {{ $t('cancel') }}
            v-btn(color='red' text @click='startDelete')
              | {{ $t('delete') }}

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductImageItem',
  props: ['settings', 'image'],
  data: () => ({
    openDeleteDialog: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.axios.delete(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/images/${this.image.id}`)
        .then(() => {
          this.$emit('deleted', this.image)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.count-layout {
  position: absolute;
  right: 10px;
  top: 6px;
}
.product-title {
  font-size: 16px;
  font-weight: bold;
  height: 2.8em; 
  line-height: 1.4em; 
  overflow: hidden;
}
.product-description {
  font-size: 12px;
  height: 3.3em; 
  text-overflow: ellipsis; 
  line-height: 1.1em; 
  white-space: pre-wrap;
  overflow: hidden;
}
.product-price {
  font-size: 16px;
  font-weight: bold;
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>
